<template>
  <div class="rw_tg">
    <img
        :src="item.icon"
        loading="lazy"
        alt=""
        class="rw_tg_ico"
    >
    <div class="b">{{ item.label  }}</div>

  </div>
</template>

<script>
import Options from "@/config/options";
export default {
  name: 'InfoBoxValue',
  props: {
    value: {
      type: String,
      required: true
    },
    context: String

  },
  methods: {

  },
  computed: {
    item(){
      return Object
          .entries(Options[this.context]).map(([, item]) => item)
          .filter(item => item.value === this.value)[0];
    }
  }
};
</script>

<style scoped>
/* Add styles here if needed */
.rw_tg_ico {
  width: 20px;
  margin-right: 7px;
}
.b {
  font-weight: 500;
}
img{min-height: 23px;
  object-fit: contain;
}
</style>
